import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { mergeMap, map } from 'rxjs';
import { CitiesService } from 'src/app/services/cities.service';
import { LocationActions } from '../actions';

@Injectable()
export class LocationEffects {
  loadCities$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LocationActions.loadCities),
      mergeMap(() => {
        return this.citiesService.load().pipe(
          map((cities) => {
            return LocationActions.loadCitiesSuccess({ cities });
          })
        );
      })
    )
  );

  constructor(
    private actions$: Actions,
    private citiesService: CitiesService
  ) {}
}
